import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-save-icon',
  templateUrl: './save-icon.component.html',
  styles: []
})
export class SaveIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
